module.exports = __webpack_public_path__ + "img/book-07.59c1be2d.png";